import PageTitle from "../../../Components/UI/PageTitle";
import { useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import FormField from "../../../Components/Form/FormField";
import TextareaForm from "../../../Components/Form/TextareaForm";
import FileInput from "../../../Components/Form/FileInput";
import DropdownForm from "../../../Components/Form/DropdownForm";
import ConfirmCheckBox from "../../../Components/Form/ConfirmCheckBox";
import RowLoader from "../../../Components/UI/RowLoader";
import { MESSAGE_TYPES } from "../../../constants/globals";
import { sendNewMessage } from "../../../apis";
import { useNavigate } from "react-router-dom";

const SendNewMessage = () => {
  const [image, setImage] = useState("");
  const navigate = useNavigate();

  const initialValues = {
    message_title: "",
    message_type: "",
    message_details: "",
    message_image: "",
    confirm: "",
  };

  const validationSchema = Yup.object().shape({
    message_title: Yup.string().required("message title is required"),
    message_type: Yup.string().required("message type is required"),
    message_details: Yup.string().required("message details is required"),
    confirm: Yup.boolean().oneOf([true], "You must confirm your choices"),
  });

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    const handleIntialValues = { ...initialValues };
    delete handleIntialValues.confirm;
    const handleValues = { ...values };
    delete handleValues.confirm;

    try {
      // Create FormData object
      const formData = new FormData();

      formData.append("message_title", values.message_title);
      formData.append("message_type", values.message_type);
      formData.append("message_details", values.message_details);

      if (values.message_image) {
        formData.append("message_image", values.message_image);
      }

      await sendNewMessage(formData);

      // Show success alert
      Swal.fire({
        title: "Success!",
        text: "Your message was sent successfully.",
        icon: "success",
        confirmButtonText: "OK",
      }).then(() => {
        resetForm();
        setImage("");
        navigate("/messages");
      });
    } catch (error) {
      console.error("Error submitting form:", error);

      // Show error alert
      Swal.fire({
        title: "Error!",
        text: error.response.data.message.join(" , "),
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setSubmitting(false); // Stop form submitting state
    }
  };

  const handleRemoveImage = (name, formField) => {
    setImage("");
    formField(name, "");
  };

  return (
    <>
      <PageTitle
        title={"Send New Message"}
        BreadcrumbItems={[
          { title: "Home", link: "/" },
          {
            title: "Messages",
            link: `/messages`,
          },
          {
            title: "Send New Message",
          },
        ]}
      />
      <p className="tw-text-[#BF0404] tw-text-end tw-mb-1">
        * means this field is required
      </p>

      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {({
          errors,
          touched,
          handleBlur,
          handleChange,
          setFieldValue,
          values,
          isSubmitting,
        }) => (
          <Form className="d-flex flex-column">
            <div className="card !tw-rounded-xl">
              <div className="card-body tw-shadow-xl tw-rounded-xl">
                <div className="row">
                  {/* message_title */}

                  <FormField
                    name={"message_title"}
                    label={"Message Title"}
                    placeholder={"Message Title"}
                    touched={touched}
                    errors={errors}
                    col_md={"6"}
                    handleBlur={handleBlur}
                    handleChange={handleChange}
                    setFieldValue={setFieldValue}
                    value={values.message_title}
                  />

                  {/* Message Type */}
                  <DropdownForm
                    handleChange={handleChange}
                    name={"message_type"}
                    dataToDrop={MESSAGE_TYPES}
                    error={errors.message_type}
                    touched={touched.message_type}
                    label={"Message Type"}
                    placeholder={"Message Type"}
                    labelKey="label"
                    valueKey="id"
                  />

                  {/* message details */}
                  <TextareaForm
                    name={"message_details"}
                    placeholder={"Message Details"}
                    touched={touched.message_details}
                    errors={errors.message_details}
                    handleBlur={handleBlur}
                    label={"Message Details"}
                  />

                  {/* Image */}
                  <FileInput
                    name="image"
                    label="Upload Message Image"
                    value={image}
                    onChange={setFieldValue}
                    onRemove={handleRemoveImage}
                    error={errors.image}
                    touched={touched.image}
                    setPhoto={setImage}
                    notRequired
                  />

                  <ConfirmCheckBox
                    label="I confirm that, all inputs data are correct."
                    name="confirm"
                  />
                  <div className="col-md-12 tw-flex">
                    <button
                      type="submit"
                      className="btn btn-primary ml-auto !tw-w-[100px] !tw-mt-4"
                    >
                      {isSubmitting ? (
                        <RowLoader paddingStyle="tw-py-0" />
                      ) : (
                        "Send"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default SendNewMessage;
